export default __webpack_public_path__ + "e63f6e49410fc5664b956e46cad8ba73.png";